import { latLng } from 'leaflet'

const useSearchResultsMapOptions = () => {
  const mapSettings = reactive({
    limits: true,
    fullsize: false,
    isAnimatingZoom: true
  })

  const mapOptions = ref({
    zoom: 13,
    zoomControl: false,
    attributionControl: false,
    center: latLng(0, 0),
    scrollWheelZoom: true,
    minZoom: 2
  })

  return { mapSettings, mapOptions }
}

export default useSearchResultsMapOptions
